import { useLazyQuery } from "@apollo/client";
import {
  GetJobScheduleStatsQuery,
  GetJobScheduleStatsQueryVariables,
  useGetJobScheduleStatsLazyQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

interface UseGetJobScheduleStatsProps {
  startDate: string;
  endDate: string;
}

export default function useGetJobScheduleStats() {
  const [query, { data: graphqlData, loading, error }] = useGetJobScheduleStatsLazyQuery();

  const getJobScheduleStats = useCallback(
    ({ startDate, endDate }: UseGetJobScheduleStatsProps) => {
      return query({
        variables: {
          startDate,
          endDate,
        },
      });
    },
    [query]
  );

  const stats = useMemo(() => {
    return graphqlData?.getJobScheduleStats ?? null;
  }, [graphqlData]);

  return [getJobScheduleStats, { data: graphqlData, loading, error, stats }] as const;
}
